import React from 'react'
import { Typography } from '@mui/material'
import Grid2 from '@mui/material/Unstable_Grid2' // Grid version 2
import * as Money from '../utilities/money'
import { Colors } from '../styles/theme'

import GridBomSelect from './GridBomSelect.js'
import CorrectCopyright from './CorrectCopyright.js'

function calcLineItemTotal(productRow) {
    return Money.getLineItemTotal(
        productRow['itemQty'],
        productRow['sugRetail']
    )
}

const sxLinkLike = {
    fontWeight: '500',
    color: `${Colors.companyColors.eb_text}`,
    textDecoration: 'underline',
    '&:hover': {
        cursor: 'pointer',

        fontSize: '103%' /* Increase font size on hover */,
        // backgroundColor: `${Colors.secondary}`,

        color: `${Colors.companyColors.eb_bolt}`,
        // textShadow: ' 0.15px 0.15px 0.15px #000',
        fontWeight: '500',
    },
}

export default function DesktopLineItem({
    productRow,
    productProp,
    handleInputChange,
    handleValue,
    showDialog,
}) {
    // console.log(`A productRowCell or DesktopLineItem`)

    let sxItem = {
        pt: 1,
        pb: 0.6,
        // fontSize: '.95rem',
    }

    function getCellItem(productRow, productProp) {
        const itemContent = {
            productID: () => (
                <Typography sx={sxItem}>{productRow[productProp]}</Typography>
            ),
            descriptionTitle: () => (
                <Typography
                    sx={{ ...sxItem, fontWeight: 300, ...sxLinkLike }}
                    onClick={showDialog}
                >
                    <CorrectCopyright
                        copyrightTextValue={productRow[productProp]}
                    />
                    {/* {correctCopyRight()} */}
                    {/* <Link href={href}>{productRow[productProp]}</Link> */}
                </Typography>
            ),

            pkgQty: () => (
                <Typography sx={sxItem}>{productRow[productProp]}</Typography>
            ),
            sugRetail: () => (
                <Typography sx={sxItem}>{productRow[productProp]}</Typography>
            ),
            itemQty: () => (
                <GridBomSelect
                    productRow={productRow}
                    handleInputChange={handleInputChange}
                    handleValue={handleValue}
                />
            ), //fontSize: '0.97rem'
            lineItemTotal: () => (
                <Typography sx={{ ...sxItem, fontWeight: 500 }}>
                    {calcLineItemTotal(productRow)}
                </Typography>
            ),
        }
        const v = itemContent[productProp]()
        return v
    }

    const itemColumns = {
        productID: 3,
        descriptionTitle: 8,
        pkgQty: 1,
        sugRetail: 3,
        itemQty: 3,
        lineItemTotal: 2,
    }

    const itemAlignment = {
        productID: 'left',
        descriptionTitle: 'left',
        pkgQty: 'right',
        sugRetail: 'right',
        itemQty: 'right',
        lineItemTotal: 'right',
    }
    const itemMargin = {
        productID: { pl: 1.5 },
        descriptionTitle: { pl: 1.5 },
        pkgQty: {},
        sugRetail: { pr: 2.5 },
        itemQty: { pr: 4.4, pt: 0.7 },
        lineItemTotal: { pr: 2 },
    }

    let href = productRow.href
    let cell = getCellItem(productRow, productProp, href)

    return (
        <Grid2
            md={itemColumns[productProp]}
            key={productRow.productID} // TODO: 07/03/23 unneccessary done above in BomTable?
            sx={{
                textAlign: itemAlignment[productProp],
                ...itemMargin[productProp],
            }}
        >
            {cell}
        </Grid2>
    )
}
